// src/components/ProductCard.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";

function formatCOP(n) {
  return new Intl.NumberFormat("es-CO", {
    style: "currency", currency: "COP", minimumFractionDigits: 0
  }).format(n);
}

export default function ProductCard({ product }) {
  const { addToCart } = useCart();
  const [adding, setAdding] = useState(false);
  const [imgIdx, setImgIdx] = useState(0);

  const {
    id, name, shortDesc, category,
    price, originalPrice,
    images = [], badge,
    variants = [], variantStock = [],
    active, stock
  } = product;

  const hasVariants  = variantStock.length > 0;
  const hasDiscount  = originalPrice && originalPrice > price;
  const discountPct  = hasDiscount
    ? Math.round((1 - price / originalPrice) * 100) : 0;
  const outOfStock   = stock <= 0;
  const mainImg      = images[imgIdx] || images[0] || null;

  const handleAddToCart = (e) => {
    e.preventDefault(); // no navegar al detalle
    if (hasVariants || outOfStock) return;
    setAdding(true);
    addToCart({ ...product, quantity: 1 });
    setTimeout(() => setAdding(false), 1200);
  };

  if (!active) return null;

  return (
    <div className="pc-card">

      {/* ── IMAGEN ── */}
      <Link to={`/producto/${id}`} className="pc-img-wrap">
        {mainImg
          ? <img src={mainImg} alt={name} className="pc-img"/>
          : <div className="pc-img-placeholder">📦</div>
        }

        {/* Badges sobre la imagen */}
        {badge && <span className="pc-badge">{badge}</span>}
        {hasDiscount && (
          <span className="pc-discount-badge">-{discountPct}%</span>
        )}
        {outOfStock && (
          <div className="pc-sold-out">Agotado</div>
        )}

        {/* Puntos de imagen si hay varias */}
        {images.length > 1 && (
          <div className="pc-img-dots">
            {images.map((_, i) => (
              <button
                key={i}
                className={`pc-img-dot ${i === imgIdx ? "active" : ""}`}
                onMouseEnter={() => setImgIdx(i)}
                onClick={e => { e.preventDefault(); setImgIdx(i); }}
              />
            ))}
          </div>
        )}
      </Link>

      {/* ── CUERPO ── */}
      <div className="pc-body">
        {category && <span className="pc-category">{category}</span>}

        <Link to={`/producto/${id}`} className="pc-title">{name}</Link>

        {shortDesc && <p className="pc-desc">{shortDesc}</p>}

        {/* Variantes disponibles */}
        {hasVariants && (
          <div className="pc-variants">
            {variantStock.slice(0, 5).map((v, i) => (
              <span
                key={i}
                className={`pc-variant-chip ${v.stock <= 0 ? "pc-variant-out" : ""}`}
                title={v.stock <= 0 ? "Agotado" : `Stock: ${v.stock}`}
              >
                {v.name}
              </span>
            ))}
            {variantStock.length > 5 && (
              <span className="pc-variant-more">+{variantStock.length - 5}</span>
            )}
          </div>
        )}

        {/* Precios */}
        <div className="pc-price-row">
          <div className="pc-prices">
            {hasDiscount && (
              <span className="pc-price-original">{formatCOP(originalPrice)}</span>
            )}
            <span className="pc-price">{formatCOP(price)}</span>
          </div>

          {/* Boton agregar al carrito */}
          {hasVariants ? (
            <Link to={`/producto/${id}`} className="pc-btn-select">
              Ver opciones
            </Link>
          ) : (
            <button
              className={`pc-btn-add ${adding ? "pc-btn-adding" : ""} ${outOfStock ? "pc-btn-disabled" : ""}`}
              onClick={handleAddToCart}
              disabled={outOfStock || adding}
              title={outOfStock ? "Sin stock" : "Agregar al carrito"}
            >
              {adding ? "✓" : outOfStock ? "Agotado" : (
                <>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2.5">
                    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
                    <line x1="3" y1="6" x2="21" y2="6"/>
                    <path d="M16 10a4 4 0 01-8 0"/>
                  </svg>
                  Agregar
                </>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
